import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Filter, Header } from './component';
import { DataTable, Excel } from 'CommonComponent';
import { getMonthlyProgramTimesheet, exportHandler } from 'actions';
import { isEmpty } from 'lodash';
import { Link, useLocation } from 'react-router-dom';
import moment from "moment-timezone";

const TimeByProgram = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [columns, setColumns] = useState([]);
    const [extraFiltersState, setExtraFiltersState] = useState({
        values: {
            year: moment().format('YYYY'),
            month: moment().format('M'),
            selectedDate: moment(),
            formatDate: moment().format('YYYY-MM'),
            program: []
        }
    });

    const session = useSelector((s) => s.session);
    const { data, headers, loading } = useSelector(state => state.timesheetReportsState.timeByProgram);

    const object_viewed_id = session?.current_page_permissions?.object_id || "";
    
    useEffect(() => {
        if (session.current_page_permissions.page_url === location.pathname) {
            filterTable();
        }
    }, [session.current_page_permissions]);

    useEffect(() => {
        if (headers) {
            const generatedColumns = generateColumns(headers);
            setColumns(generatedColumns);
        }
    }, [headers]);

    // Helper function to format hours/amounts
    const formatValue = (value, isOT) => {
        if (typeof value === 'number') {
            return (
                <span style={{ color: isOT ? 'red' : 'inherit' }}>
                    {value.toFixed(2)}
                </span>
            )
        }
        return 'value';
    };

    const generateColumns = (headers) => {
        const staticColumns = [
            {
                id: "program_name",
                header: "Program",
                accessor: (row) => row.program_name,
                sortable: true,
                searchable: true,
            },
            {
                id: "type",
                header: "Type",
                accessor: (row) => row.type,
                sortable: false,
                searchable: false,
                cell: (value) => (
                    <span style={{ color: value === 'OT' ? 'red' : 'inherit', fontWeight: value === 'OT' ? 'bold' : 'normal' }}>
                        {value}
                    </span>
                )
            },
            {
                id: "month_total",
                header: "Total Month",
                accessor: (row) => row,
                sortable: false,
                cell: (row) => formatValue(row.month_total, row.type === 'OT'),
                searchable: false,
            },
        ];

        const dynamicColumns = Object.entries(headers).map(([key, header]) => {
            if (!['program_name', 'type', 'month_total'].includes(key)){
                const dateParts = key.split('_').slice(-3);
                const formattedDate = `${dateParts[2]}-${dateParts[0]}-${dateParts[1]}`;
                return {
                    id: key,
                    header: header,
                    accessor: (row) => row,
                    cell: (row) => (
                        <Link to={`/teamWeeklytimesheet?week_end_date=${formattedDate}&program_id=${row.program_id}`}>
                           {formatValue(row[key], row.type === 'OT')}
                        </Link>
                    ),
                    sortable: false,
                    searchable: false,
                }
            } 
            return null;
            
        }).filter(Boolean);

        return [...staticColumns, ...dynamicColumns];
    };

    const filterTable = () => { 
        if (!isEmpty(extraFiltersState.values.formatDate) ) {
            dispatch(getMonthlyProgramTimesheet({ ...extraFiltersState.values, object_viewed_id }));
        }
        else{  
            dispatch({ type: 'CLEAR_MONTHLY_PROGRAM_TIMESHEETS_REPORT' });
            //setColumns([]);
        }
    };

    const handleExport = () => {
        dispatch(exportHandler(
            'timesheet/reports/monthly-program-timesheet/export', 
            extraFiltersState.values, 
            object_viewed_id, 
            'time_by_program.xlsx'
        ));
    };

    

    return (
        <div className='wrapper-div'>
            <Header />
            <div className="d-flex justify-content-end align-items-center gap-3 p-4">
                
                <Excel  handleExport={handleExport} />
                
            </div>
            <Filter onFilter={filterTable} extraFiltersState={extraFiltersState} setExtraFiltersState={setExtraFiltersState} />
            <DataTable
                columns={columns}
                data={data}
                serverSide={false}
                showSearch={false}
                loading={loading}
                className='table-container'
            />
        </div>
    )
}

export default TimeByProgram;
